import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import DropdownFilter from 'components/DropdownFilter';
import css from './ContactsList.module.scss';
import formHelper from 'js/form-helper';
import ContactBlock from 'components/ContactBlock';
import ListSearchForm from 'components/ListSearchForm';
import Button from '../Button/Button';
import api from 'js/api-helper';
import replaceQueryParameters from '@creuna/utils/replace-query-parameters';

const SEARCH_NAME = "q";
const FILTER_NAME = "company";

class ContactsList extends React.Component {
    static propTypes = {
        companiesFilter: PropTypes.shape(DropdownFilter.propTypes),
        loadItemsEndpoint: PropTypes.string,
        pageSize: PropTypes.number,
        lang: PropTypes.shape({
            loadMoreButtonText: PropTypes.string.isRequired,
            sendEmailLabel: PropTypes.string.isRequired,
            searchInputPlaceholder: PropTypes.string.isRequired,
            searchInputLabel: PropTypes.string.isRequired,
            searchButtonText: PropTypes.string.isRequired,
            errorMessage: PropTypes.string.isRequired,
            noResultsText: PropTypes.string.isRequired,
            searchHitsText: PropTypes.string.isRequired
        }).isRequired
    }

    constructor(props) {
        super(props);
        this.state = {
            query: {},
            listItems: [],
            isLoading: true,
            showError: false,
            page: 1,
            totalCount: null,
        };
    }

    buildInitQuery = () => {
        var query = formHelper.createQuery();
        formHelper.fillQueryFromPageQueryString(query);
        return query;
    };

    onFilterChange = (e, activeIndex) => {
        var query = this.state.query;
        formHelper.setToQueryFilterOptions(query, this.props.companiesFilter, FILTER_NAME, activeIndex);    
 
        this.setState({query: query, page: 1 }, () => {
            this.loadContacts();
        });

        formHelper.updatePageQueryString(query);
    };

    onFormSubmit = (searchValue) => {
        var query = this.state.query;
        formHelper.setToQueryTextInputValue(query, SEARCH_NAME, searchValue);

        this.setState({ query: query, page: 1 }, () => {
            this.loadContacts();
        });
        formHelper.updatePageQueryString(query);
    };

    loadContacts = () => {
        this.setState({
            isLoading: true,
            showError: false,
        });
        const ENDPOINT = this.props.loadItemsEndpoint;
        let query = Object.assign({}, this.state.query);
        query = Object.assign(query, { page: this.state.page, pageSize: this.props.pageSize });
        var searchEndpoint = ENDPOINT.indexOf('data/static-site') !== -1 ? ENDPOINT : replaceQueryParameters(ENDPOINT, query);
        api
            .get(searchEndpoint)
            .then(response => {
                let loadedContacts = response.contacts ? response.contacts : [];

                this.setState(prevState =>({
                    isLoading: false,
                    listItems : this.state.page == 1 ? [...loadedContacts] : [...prevState.listItems, ...loadedContacts],
                    totalCount: response.totalCount,
                }));
            })
            .catch(() => {
                this.setState({
                    isLoading: false,
                    showError: true,
                });
            });
    } 

    onLoadMore = () => {
        this.setState({page: this.state.page + 1}, () => {
            this.loadContacts();
        });
    };

    checkKeyMatchFilterKeys(keyToCheck, itemsArray) {
        for (const item of itemsArray) {
            if (item.key === keyToCheck) {
                return true;
            }
        }
        return false;
    }

    componentWillMount() {
        if (typeof window !== 'undefined') {
            var initQuery = this.buildInitQuery();
            this.setState({ query: initQuery });
        }
    }
    
    componentDidMount() {
        this.loadContacts();
    }

    render() {
        const {
            companiesFilter,
            lang,
        } = this.props;

        const {
            listItems,
            showError,
            totalCount,
            isLoading,
            query,
        } = this.state;

        return (
            <div
                className={css.wrapper}
            >
                <div className={cn(css.filter)}>
                    <div className={cn(css['filter-container'], isLoading ? css['loading'] : null)}>
                        <DropdownFilter
                            {...companiesFilter}
                            name={FILTER_NAME}
                            onSelect={this.onFilterChange}
                            yellow
                            multy={false}
                            className={css.companies}
                            active={this.checkKeyMatchFilterKeys(Number(query[FILTER_NAME]), companiesFilter.items) ? Number(query[FILTER_NAME]) : null}
                        />
                    </div>
                </div>
                <ListSearchForm 
                    searchInputLabel={lang.searchInputLabel}
                    searchButtonAriaLabel={lang.searchButtonText}
                    searchInputPlaceholder={lang.searchInputPlaceholder}
                    searchParamName={SEARCH_NAME}
                    defaultValue={query[SEARCH_NAME]}
                    isLoading={isLoading}
                    totalListItemsCount={totalCount}
                    listItemsCount={listItems.length}
                    searchHitsText={lang.searchHitsText}
                    noResultsText={lang.noResultsText}
                    onFormSubmit={this.onFormSubmit}
                />
                <div className={css['contacts-list']}>
                    <ContactBlock
                        heading={null}
                        sendEmailLabel={lang.sendEmailLabel}
                        contacts={listItems}
                        small={true}
                        className='contact-block_in-contacts-list'
                    />
                    
                    {listItems && listItems.length > 0 && totalCount && (listItems.length < totalCount) &&
                    <Button 
                        className={css['load-more-button']} 
                        secondary 
                        onClick={this.onLoadMore}
                        disabled={isLoading}
                    >{lang.loadMoreButtonText}</Button>
                    }
                    {showError && lang.errorMessage &&
                    <div className={css.error}>{lang.errorMessage}</div>
                    }
                </div>
            </div>
        );
    }
}

export default ContactsList;



// WEBPACK FOOTER //
// ./src/components/ContactsList/ContactsList.jsx